var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.itens.length > 0)?_c('div',{staticClass:"banner"},[_c('div',{staticClass:"relative w-full overflow-hidden rounded-lg shadow bg-default-400 h-vmax-15 mb-4 banner-height"},[_c('carousel',{attrs:{"itens":_vm.itens}})],1)]):_c('div',{staticClass:"banner"})
}
var staticRenderFns = []

export { render, staticRenderFns }